module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-left-active-58f05b23ae0a899d3f3a0bec296fe9bf.svg";